/* eslint-disable */
export default {
  ringtones: 'Toques',
  incomingRingtone: 'Toque de entrada',
  outgoingRingtone: 'Toque de saída',
  play: 'Reproduzir',
  stop: 'Parar',
  upload: 'Carregar',
  reset: 'Repor',
  save: 'Guardar',
} as const;

// @key: @#@"ringtones"@#@ @source: @#@"Ringtones"@#@
// @key: @#@"incomingRingtone"@#@ @source: @#@"Incoming Ringtone"@#@
// @key: @#@"outgoingRingtone"@#@ @source: @#@"Outgoing Ringtone"@#@
// @key: @#@"play"@#@ @source: @#@"Play"@#@
// @key: @#@"stop"@#@ @source: @#@"Stop"@#@
// @key: @#@"upload"@#@ @source: @#@"Upload"@#@
// @key: @#@"reset"@#@ @source: @#@"Reset"@#@
// @key: @#@"save"@#@ @source: @#@"Save"@#@
